import React, { useState, useEffect } from "react";
import { LogOut } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "components/ui/alert";
import { Button } from "components/ui/button";

function LoggedOut() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown === 0) {
      window.location.href = "/";
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="w-full max-w-md p-4">
        <Alert>
          <LogOut className="h-4 w-4" />
          <AlertTitle className="font-bold text-lg">
            You have been logged out
          </AlertTitle>
          <AlertDescription>
            <p className="mt-2">
              Your session has expired or you've been logged out for security
              reasons.
            </p>
            <p className="mt-4 text-sm text-muted-foreground">
              Redirecting to the home page in{" "}
              <span className="font-semibold text-foreground">{countdown}</span>{" "}
              seconds...
            </p>
          </AlertDescription>
        </Alert>
        <Button
          onClick={() => (window.location.href = "/")}
          className="w-full mt-4 bg-gradient-to-r from-[#005151] to-[#004040] hover:from-[#004040] hover:to-[#003030] text-white"
        >
          Go to Home
        </Button>
      </div>
    </div>
  );
}

export default LoggedOut;
